
/* eslint-disable arrow-body-style,no-underscore-dangle,no-inline-comments,line-comment-position,array-element-newline */
import {
  h, resolveComponent, defineComponent, ref, reactive,
} from 'vue';

/**
 * 清单污染源弹窗 = ListCommonPopup(维护差异性的入口) + BasePopup（统一基础弹窗 插槽提供差异性的调整 兼容非清单污染源但未实现） + ListBaseInfo (BasePopup-slot 差异性的基础信息 其他弹窗若无差异性 可以合并至BasePopup)
 * TODO:
 * 理想状态 两类弹窗 => 清单污染源弹窗+非清单污染源弹窗
 * 差异化特质分为两块结构 => 基础信息区域 ListBaseInfo + 图表视频展示区 ContentInfo
 * 其中 统一非清单污染源与清单污染源的基础信息区域后 建议修改组件名称 ListBaseInfo => BaseInfo
 * ContentInfo = EchartInfo + VideoInfo
 */
import ListCommonPopup from './ListCommonPopup.vue';
// 其他弹窗
import envPopUp from './envPopUp.vue';
import construPopUp from './construPopUp.vue';
import cookingPopUp from './cookingPopUp.vue';
import weatherPopUp from './weatherPopUp.vue';
import companyPopUp from './companyPopUp.vue';
import CameraPopUp from './cameraPopUp.vue';

export default defineComponent({
  components: {
    commonList: ListCommonPopup,
    camera: CameraPopUp,
    env: envPopUp,
    construction: construPopUp,
    cookingFume: cookingPopUp,
    weather: weatherPopUp,
    company: companyPopUp,
  },
  emits: [
    'close',
    'exceedChange',
  ],
  setup (props, { emit, expose, }) {
    const _componentName = ref(''); // 组件名称
    const _componentOptions = reactive({
      data: {},
    }); // 各组件渲染所需参数
    const setInfoValue = (componentOptions: any) => {
      _componentName.value = componentOptions.nodeType || componentOptions.popupData.nodeType;
      _componentOptions.data = componentOptions;
    };

    expose({ setInfoValue, });

    return () => {
      if (_componentName.value) {
        return h(resolveComponent(_componentName.value), {
          ..._componentOptions.data,
          onClose: () => emit('close'),
          onExceedChange: (val:any) => emit('exceedChange',val),
        });
      }

      return h('div', null, '');
    };
  },
});
